<div class="header-block" #headerBlock>
    <ng-container *ngIf="columnData">
        <div
            class="header-container"
            [ngClass]="columnPalette ? 'justify-center' : 'justify-between'"
            [cdkMenuTriggerFor]="menuColumn"
        >
            <ng-container [ngTemplateOutlet]="headerContent"></ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="!columnData">
        <div class="header-container" [ngClass]="columnPalette ? 'justify-center' : 'justify-between'">
            <ng-container [ngTemplateOutlet]="headerContent"></ng-container>
        </div>
    </ng-container>
</div>

<ng-template #headerContent>
    <!-- Тултип / title -->
    <ng-container *ngIf="!columnPalette">
        <div
            [fuiTooltip]="columnData.title | escapeHtml"
            class="header-column-label"
            [innerHTML]="columnData.title | escapeHtml"
        ></div>

        <!-- Кнопка меню -->
        <div class="header-container-button-menu">
            <fui-button
                [title]="dictionary.system_actions"
                type="button-icon"
                color="gray"
                height="slim"
                icon="dots-vertical"
            >
            </fui-button>
        </div>
    </ng-container>
    <ng-container *ngIf="columnPalette">
        <div class="palette-icon-block">
            <mat-icon
                class="table-color-history"
                [fuiTooltip]="columnPalette.title"
                #menuColorHistoryTrigger="cdkMenuTriggerFor"
                [cdkMenuTriggerFor]="menuColorHistory"
                (click)="$event.stopPropagation()"
                fontSet="mdi"
                [fontIcon]="'mdi-' + columnPalette.icon"
            ></mat-icon>
            <ng-template #menuColorHistory>
                <div cdkMenu class="relative rounded bg-surf-container-lowest border border-outline-variant py-2">
                    <app-palette-legend [palette]="columnPalette"></app-palette-legend>
                    <div class="absolute top-1 right-1">
                        <fui-button
                            type="button-icon"
                            height="slim"
                            borderRadius="circle"
                            color="flat"
                            icon="close"
                            (clickEvent)="menuColorHistoryTrigger.close()"
                            title="{{ dictionary.system_close }}"
                        ></fui-button>
                    </div>
                </div>
            </ng-template>
        </div>
    </ng-container>
    <!-- Иконка направления сортировки -->
    <ng-container *ngIf="(columnData?.sortDirection ?? '') !== '' || (columnData?.groupDirection ?? '') !== ''">
        <div
            class="header-container-icon-sort"
            [class.desc]="
                (columnData?.groupDirection ?? '') !== ''
                    ? columnData?.groupDirection === 'desc'
                    : columnData?.sortDirection === 'desc'
            "
            [ngClass]="columnPalette ? '' : 'mr-0.5'"
        >
            <fui-icon type="button-icon" icon="arrow-up-thin" size="1.25"></fui-icon>
        </div>
    </ng-container>
</ng-template>

<ng-template #menuColumn>
    <div fuiMenu class="context-menu">
        <!-- Фильтровать -->
        <button fuiMenuItem (click)="filterRunEmitted()">
            <fui-icon icon="filter-outline"></fui-icon>
            <span>{{ dictionary.t_filter }}</span>
        </button>

        <!-- Переименовать -->
        <button fuiMenuItem (click)="showRenamePopup(columnData.name, columnData.title)">
            <fui-icon icon="pencil-outline"></fui-icon>
            <span>{{ dictionary.t_rename }}</span>
        </button>

        <ng-container *ngIf="columnData.sortDirection !== 'asc'; else cancelSort">
            <!-- Сортировка по возрастанию -->
            <button
                fuiMenuItem
                [disabled]="!!columnData.groupDirection"
                (click)="sortRun.emit({ userColumnName: columnData.name, sortDirection: 'asc' })"
            >
                <fui-icon icon="sort-ascending"></fui-icon>
                <span>{{ dictionary.t_sort_in_asc_order }}</span>
            </button>
        </ng-container>

        <ng-container *ngIf="columnData.sortDirection !== 'desc'; else cancelSort">
            <!-- Сортировка по убыванию -->
            <button
                fuiMenuItem
                [disabled]="!!columnData.groupDirection"
                (click)="sortRun.emit({ userColumnName: columnData.name, sortDirection: 'desc' })"
            >
                <fui-icon icon="sort-descending"></fui-icon>
                <span>{{ dictionary.t_sort_in_desc_order }}</span>
            </button>
        </ng-container>

        <!-- Шаблон кнопки отмены сортировки-->
        <ng-template #cancelSort>
            <button
                fuiMenuItem
                [disabled]="!!columnData.groupDirection"
                (click)="sortRun.emit({ userColumnName: columnData.name, sortDirection: '' })"
            >
                <fui-icon
                    [icon]="columnData.sortDirection === 'desc' ? 'sort-descending' : 'sort-ascending'"
                ></fui-icon>
                <span>{{ dictionary.t_cancel_sort_order }}</span>
            </button>
        </ng-template>

        <!-- Группировка (только для реестра) -->
        <ng-container *ngIf="showGroupMenuItem()">
            <ng-container *ngIf="!columnData.groupDirection">
                <button
                    fuiMenuItem
                    (click)="groupRun.emit([{ userColumnName: columnData.name, sortDirection: 'asc' }])"
                >
                    <fui-icon icon="list-box-outline"></fui-icon>
                    <span>{{ dictionary.t_group }}</span>
                </button>
            </ng-container>
            <ng-container *ngIf="!!columnData.groupDirection">
                <button fuiMenuItem (click)="groupRun.emit([])">
                    <fui-icon icon="list-box-outline"></fui-icon>
                    <span>{{ dictionary.t_cancel_group }}</span>
                </button>
            </ng-container>
        </ng-container>

        <!-- Суммировать (пока не реализовано) -->
        <!-- <button -->
        <!--     fuiMenuItem -->
        <!--     (click)="summarizeRun.emit({ userColumnName: columnData.name })" -->
        <!--     class="context-menu-item" -->
        <!-- > -->
        <!--     <fui-icon icon="sigma"></fui-icon> -->
        <!--     <span>{{ dictionary.t_summarize }}</span> -->
        <!-- </button>-->

        <!-- Закрепить/Открепить -->
        <button
            fuiMenuItem
            (click)="pinToggleRun.emit({ userColumnName: columnData.name, isSticky: !columnData.is_sticky })"
        >
            <fui-icon [icon]="columnData.is_sticky ? 'pin-off-outline' : 'pin-outline'"></fui-icon>
            <span>{{ columnData.is_sticky ? dictionary.t_unpin : dictionary.t_to_fix }}</span>
        </button>

        <!-- Скрыть -->
        <button fuiMenuItem (click)="hideRun.emit({ userColumnName: columnData.name })">
            <fui-icon icon="eye-outline"></fui-icon>
            <span>{{ dictionary.hide }}</span>
        </button>
    </div>
</ng-template>

<app-table-rename-column #tableRenameColumnComponent [data]="renameData$ | async"> </app-table-rename-column>
